import React from "react";
import {
  create80x35,
  create50x50,
  create50x40,
  create40x20,
  create40x25,
  create50x25,
  create40x20NFS,
  create45x90,
} from "./utils/printUtils";
import { postPrnFile } from "../../../../../config/Services";

const data = [
  {
    itemName: "LOOSE BESTPRICE POHA MOTA",
    weight: 40,
    quantityUnits: 3,
    gtin: "101514756",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "2734.00",
    lotNo: "POH23K10",
  },
  {
    itemName: "LOOSE BESTPRICE JEERA SAMBA RICE",
    weight: 30,
    quantityUnits: 4,
    gtin: "103835334",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "4269.00",
    lotNo: "JES23K10",
  },
  {
    itemName: "LOOSE BESTPRICE JEERA SAMBA RICE",
    weight: 10,
    quantityUnits: 1,
    gtin: "103835334",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "1423.00",
    lotNo: "JES23K10",
  },
  {
    itemName: "LOOSE BESTPRICE CHANNA DAL",
    weight: 50,
    quantityUnits: 2,
    gtin: "100036155",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "6370.00",
    lotNo: "CMD23K10",
  },
  {
    itemName: "LOOSE BESTPRICE CHANNA DAL",
    weight: 20,
    quantityUnits: 1,
    gtin: "100036155",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "2548.00",
    lotNo: "CMD23K10",
  },
  {
    itemName: "LOOSE BESTPRICE MOONG DAL",
    weight: 30,
    quantityUnits: 1,
    gtin: "100036185",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "5084.00",
    lotNo: "MOD23K10",
  },
  {
    itemName: "LOOSE BESTPRICE MOONG DAL",
    weight: 20,
    quantityUnits: 1,
    gtin: "100036185",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "3389.00",
    lotNo: "MOD23K10",
  },
  {
    itemName: "LOOSE BESTPRICE GREEN PEAS",
    weight: 30,
    quantityUnits: 4,
    gtin: "100557801",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "4456.00",
    lotNo: "GRP23K10",
  },
  {
    itemName: "LOOSE BESTPRICE WHITE PEAS",
    weight: 30,
    quantityUnits: 2,
    gtin: "103568441",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "2956.00",
    lotNo: "WHP23K10",
  },
  {
    itemName: "LOOSE BESTPRICE MASOOR DAL",
    weight: 20,
    quantityUnits: 1,
    gtin: "103835457",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "2428.00",
    lotNo: "MAD23K10",
  },
  {
    itemName: "LOOSE BESTPRICE GUNTUR CHILLI WITH STEM",
    weight: 20,
    quantityUnits: 1,
    gtin: "100535381",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "7654.00",
    lotNo: "GUC23K10",
  },
  {
    itemName: "LOOSE BESTPRICE JAGGERY ROUND",
    weight: 30,
    quantityUnits: 8,
    gtin: "101323669",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "2276.00",
    lotNo: "JAG23K10",
  },
  {
    itemName: "LOOSE PALM JAGGERY",
    weight: 10,
    quantityUnits: 2,
    gtin: "111427525",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "3958.00",
    lotNo: "PAJ23K10",
  },
  {
    itemName: "LOOSE PALM JAGGERY",
    weight: 5,
    quantityUnits: 1,
    gtin: "111427525",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "1979.00",
    lotNo: "PAJ23K10",
  },
  {
    itemName: "LOOSE BESTPRICE POHA MOTA",
    weight: 40,
    quantityUnits: 3,
    gtin: "101514756",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "2734.00",
    lotNo: "POH23K10",
  },
  {
    itemName: "LOOSE BESTPRICE PALAKKAD MATTA BOILED RICE",
    weight: 26,
    quantityUnits: 2,
    gtin: "103835271",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "1870.00",
    lotNo: "PAM23K10",
  },
  {
    itemName: "LOOSE BESTPRICE CHANNA DAL",
    weight: 50,
    quantityUnits: 3,
    gtin: "100036155",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "6370.00",
    lotNo: "CMD23K10",
  },
  {
    itemName: "LOOSE BESTPRICE KABULI CHANNA SMALL",
    weight: 30,
    quantityUnits: 2,
    gtin: "100503023",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "5944.00",
    lotNo: "KCS23K10",
  },
  {
    itemName: "LOSSE BEST PRICE URAD WHITE WHOLE",
    weight: 50,
    quantityUnits: 3,
    gtin: "100557799",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "10446.00",
    lotNo: "UDW23K10",
  },
  {
    itemName: "LOOSE BESTPRICE GREEN PEAS",
    weight: 30,
    quantityUnits: 2,
    gtin: "100557801",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "4456.00",
    lotNo: "GRP23K10",
  },
  {
    itemName: "LOOSE BESTPRICE FRIED GRAM",
    weight: 30,
    quantityUnits: 4,
    gtin: "101323440",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "4601.00",
    lotNo: "FRD23K10",
  },
  {
    itemName: "LOOSE BESTPRICE GUNTUR CHILLI WITH STEM",
    weight: 20,
    quantityUnits: 1,
    gtin: "100535381",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "7654.00",
    lotNo: "GUC23K10",
  },
  {
    itemName: "LOOSE BESTPRICE JEERA WHOLE",
    weight: 30,
    quantityUnits: 1,
    gtin: "100563835",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "23821.00",
    lotNo: "JEW23K10",
  },
  {
    itemName: "LOOSE BESTPRICE JAGGARY ROUND",
    weight: 30,
    quantityUnits: 8,
    gtin: "101323669",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "2276.00",
    lotNo: "JAG23K10",
  },
  {
    itemName: "LOOSE PALM JAGGERY",
    weight: 10,
    quantityUnits: 2,
    gtin: "111427525",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "3958.00",
    lotNo: "PAJ23K10",
  },
  {
    itemName: "LOOSE PALM JAGGERY",
    weight: 5,
    quantityUnits: 1,
    gtin: "111427525",
    packedDate: "10-11-23",
    expirationDate: "6 MONTHS",
    mrp: "1979.00",
    lotNo: "PAJ23K10",
  },
];

export const TestLabel = () => {
  const handlePrint = async () => {
    const newData = data.flatMap((item) => {
      // for cloning items in the array with quantityUnits
      const clonedItems = [];
      for (let i = 0; i < item.quantityUnits; i++) {
        clonedItems.push({ ...item });
      }
      return clonedItems;
    });
    const payload = {
      data: newData,
      type: "45x90",
    };
    const file = await generatePrn(payload);
    await uploadPrn(file);
  };

  const createContent = async (data, type) => {
    switch (type) {
      case "80x35":
        return await create80x35(data);
      case "50x50":
        return await create50x50(data);
      case "50x40":
        return await create50x40(data);
      case "40x20":
        return await create40x20(data);
      case "40x25":
        return await create40x25(data);
      case "50x25":
        return await create50x25(data);
      case "40x20_nfs":
        return await create40x20NFS(data);
      case "45x90":
        return await create45x90(data);
      default:
        return null;
    }
  };

  const generatePrn = async ({ data, type }) => {
    const fileContent = await createContent(data, type);
    const prnBlob = new Blob([fileContent], { type: "multipart/form-data" });
    return prnBlob;
  };

  const uploadPrn = async (file) => {
    const formData = new FormData();
    formData.append("multipartFile", file, "output.prn");
    try {
      const response = await postPrnFile(formData);
    } catch (err) {
      console.log(err);
    }
    // export const postPrnFile = (payload) => {
    //   const url = `https://localhost:8442/v1/printer/print`
    //   return postFileRequest(url, payload);
    // };
  };

  return (
    <div>
      <button onClick={handlePrint}>Test Print</button>
    </div>
  );
};
